import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

const ModalAction = (props) => {
  const { visible, title, onClose, children } = props;

  return (
    <Modal
      show={visible}
      onHide={onClose}
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="text-xl font-semibold text-gray-600">{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

ModalAction.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

export default ModalAction;
